import { TFilter } from './filter'
import { Sorter } from './sorter'

export type Query = {
    filters?: TFilter[]
    page?: number
    pageSize?: number
    sorter?: Sorter
    params?: Record<string, any>
}

export namespace Query {
    export function build(query: Query | null | undefined): string {
        if (!query)
            return ''

        const params = new URLSearchParams()

        if (query.page != null)
            params.set('page', String(query.page))

        if (query.pageSize != null)
            params.set('pageSize', String(query.pageSize))

        if (query.filters?.length)
            params.set('filters', JSON.stringify(query.filters))

        if (query.sorter)
            params.set('sorter', JSON.stringify(query.sorter))

        if (query.params) {
            Object.entries(query.params).forEach(([key, value]) => {
                if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
                    params.set(key, String(value))
                else
                    params.set(key, JSON.stringify(value))
            })
        }

        return params.toString()
    }
}
